import { gsap } from 'gsap';

const selectors = {
  closeButton: '[data-close-button]',
  content: '[data-banner]',
}

class AnnouncementBanner extends HTMLElement {
  constructor() {
    super();

    this.handleClick = this.handleClick.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
  }

  handleClose() {
    this.classList.remove('announcement-banner--visible');
    const timeline = gsap.timeline();
    timeline.to(this.content, {
      autoAlpha: 0,
      scale: 0.95,
      duration: 0.85,
      ease: 'elastic.out(1, 0.95)',
      delay: 0.2,
    })
    timeline.call(() => {
      this.remove();
      localStorage.setItem('announcement-banner-closed', 'true');
    })
  }

  handleKeydown(event) {
    if (event.key === 'Escape') {
      this.handleClose();
    }
  }

  connectedCallback() {
    this.closeButton = this.querySelector(selectors.closeButton);
    this.content = this.querySelector(selectors.content);
    
    this.hasClosed = localStorage.getItem('announcement-banner-closed');
    
    if (this.hasClosed) {
      this.remove();
      return;
    }
    
    this.removeAttribute('inert');
    this.classList.add('announcement-banner--visible');
    
    this.closeButton?.addEventListener('click', this.handleClick);
    // window.addEventListener('keydown', this.handleKeydown, { passive: true });
  }

  disconnectedCallback() {
    this.closeButton?.removeEventListener('click', this.handleClick);
    // window.removeEventListener('keydown', this.handleKeydown, { passive: true });
  }

  handleClick(event) {
    event.preventDefault();
    this.handleClose();
  }
}

if (!customElements.get('announcement-banner')) {
  customElements.define('announcement-banner', AnnouncementBanner);
}